import React from "react";
import PropTypes from "prop-types";

export function BarItem(props) {
  const onClick = (event) => {
    event.stopPropagation();
    props.onClick(props.taskId);
  };

  const className = props.filled ? "bar_full" : "bar_empty";

  return (
    <div
      onClick={onClick}
      className={className}
      style={props.style}
      role="button"
      tabIndex="0"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          onClick;
        }
      }}
    />
  );
}

BarItem.propTypes = {
  /**
   * function to invoke when clicked
   */
  onClick: PropTypes.func,
  /**
   * TaskId associated with the barItem
   */
  taskId: PropTypes.number,
  /**
   * Boolean to set if bar is filled
   */
  filled: PropTypes.bool,
  /**
   * style to set on barItem
   */
  style: PropTypes.object,
};
